module.exports = __webpack_public_path__ + "161f7fcb431023d65bbd20417b321328.ttf";